/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Delivery_Board_Refund_LoadingInputs */

const en_delivery_board_refund_loading = /** @type {(inputs: Delivery_Board_Refund_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Processing refund...`)
};

const es_delivery_board_refund_loading = /** @type {(inputs: Delivery_Board_Refund_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Procesando reembolso...`)
};

const fr_delivery_board_refund_loading = /** @type {(inputs: Delivery_Board_Refund_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Traitement du remboursement...`)
};

const de_delivery_board_refund_loading = /** @type {(inputs: Delivery_Board_Refund_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rückerstattung wird verarbeitet...`)
};

const id_delivery_board_refund_loading = /** @type {(inputs: Delivery_Board_Refund_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Memproses pengembalian dana...`)
};

/** @type {(inputs: Delivery_Board_Refund_LoadingInputs) => LocalizedString} */
const ja_delivery_board_refund_loading = en_delivery_board_refund_loading;

/** @type {(inputs: Delivery_Board_Refund_LoadingInputs) => LocalizedString} */
const zh_delivery_board_refund_loading = en_delivery_board_refund_loading;

/** @type {(inputs: Delivery_Board_Refund_LoadingInputs) => LocalizedString} */
const ar_delivery_board_refund_loading = en_delivery_board_refund_loading;

/** @type {(inputs: Delivery_Board_Refund_LoadingInputs) => LocalizedString} */
const it_delivery_board_refund_loading = en_delivery_board_refund_loading;

/** @type {(inputs: Delivery_Board_Refund_LoadingInputs) => LocalizedString} */
const ru_delivery_board_refund_loading = en_delivery_board_refund_loading;

/** @type {(inputs: Delivery_Board_Refund_LoadingInputs) => LocalizedString} */
const pt_delivery_board_refund_loading = en_delivery_board_refund_loading;

/** @type {(inputs: Delivery_Board_Refund_LoadingInputs) => LocalizedString} */
const ko_delivery_board_refund_loading = en_delivery_board_refund_loading;

/**
* | output |
* | --- |
* | "Processing refund..." |
*
* @param {Delivery_Board_Refund_LoadingInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const delivery_board_refund_loading = /** @type {((inputs?: Delivery_Board_Refund_LoadingInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Delivery_Board_Refund_LoadingInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_delivery_board_refund_loading(inputs)
	if (locale === "es") return es_delivery_board_refund_loading(inputs)
	if (locale === "fr") return fr_delivery_board_refund_loading(inputs)
	if (locale === "de") return de_delivery_board_refund_loading(inputs)
	if (locale === "ja") return ja_delivery_board_refund_loading(inputs)
	if (locale === "zh") return zh_delivery_board_refund_loading(inputs)
	if (locale === "ar") return ar_delivery_board_refund_loading(inputs)
	if (locale === "id") return id_delivery_board_refund_loading(inputs)
	if (locale === "it") return it_delivery_board_refund_loading(inputs)
	if (locale === "ru") return ru_delivery_board_refund_loading(inputs)
	if (locale === "pt") return pt_delivery_board_refund_loading(inputs)
	return ko_delivery_board_refund_loading(inputs)
});